/* loaded by smart-asset */
export default require("./loading~xCZVzgKY.gif")